import { useLocation } from 'react-router-dom';

import { useGlobalAIAssistantFeatureEnabled } from './use-global-ai-assistant-feature-enabled';

/** True while the user is ON the assistant homepage (`/` with it enabled). */
export function useAssistantHomepageActive(): boolean {
  const enabled = useGlobalAIAssistantFeatureEnabled();
  const { pathname } = useLocation();
  return enabled && pathname === '/';
}
